import { render, staticRenderFns } from "./DistrictCreate.vue?vue&type=template&id=78fb78ff&"
import script from "./DistrictCreate.vue?vue&type=script&lang=ts&"
export * from "./DistrictCreate.vue?vue&type=script&lang=ts&"
import style0 from "./DistrictCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports